import { Typography } from 'antd';
import { FC } from 'react';

import { SearchConsoleUrlInspection } from '@/modules/DomainsApi';

interface Props {
  robotsTxtState: NonNullable<SearchConsoleUrlInspection['indexStatusResult']>['robotsTxtState'] | null;
}

export const RobotsTxtStateLabel: FC<Props> = ({ robotsTxtState }) => {
  if (robotsTxtState) {
    if (robotsTxtState === 'ALLOWED') {
      return <span>Дозволено</span>;
    }
    if (robotsTxtState === 'DISALLOWED') {
      return <span>Не дозволено</span>;
    }
    if (robotsTxtState === 'ROBOTS_TXT_STATE_UNSPECIFIED') {
      return <span>Невідомо</span>;
    }
  } else {
    return <Typography.Text>(недоступно)</Typography.Text>;
  }
};
